import { useEffect, useState } from 'react';

import { context } from '~/stormpath';

import { SalesforceUserLicensePoolAccess, getSalesforceUserLicensePoolAccess } from '~/services/SalesforceService';

type UseSalesforceUserLicenseState = {
  loading: boolean;
  userLicensePoolAccessData: SalesforceUserLicensePoolAccess;
  error: string | null;
  refresh: () => void;
};

export const useGetSalesforceUserLicense = (): UseSalesforceUserLicenseState => {
  const [state, setState] = useState({
    loading: false,
    userLicensePoolAccessData: null,
    error: null,
  });

  const loadSalesforceUserLicense = async () => {
    const userStore = context.getUserStore();
    const sessionData = userStore?.sessionStore?.get();
    const user = sessionData?.account;

    if (!user?.email) {
      setState({
        loading: false,
        userLicensePoolAccessData: null,
        error: 'User email not available',
      });
      return;
    }

    setState({
      loading: true,
      userLicensePoolAccessData: null,
      error: null,
    });

    try {
      const response = await getSalesforceUserLicensePoolAccess(user.email);
      setState({
        loading: false,
        userLicensePoolAccessData: response,
        error: null,
      });
    } catch (error: any) {
      setState({
        loading: false,
        userLicensePoolAccessData: null,
        error: error.message || 'Failed to get Salesforce user license',
      });
    }
  };

  const refresh = () => {
    loadSalesforceUserLicense();
  };

  useEffect(() => {
    loadSalesforceUserLicense();
  }, []);

  return {
    ...state,
    refresh,
  };
};
